<template>
  <img :src="logo" height="32px" alt="" @error="logo = fallback" />
</template>

<script>
import region, { DEFAULT_LOGO } from '@/config/regions';

export default {
  data() {
    return {
      // Per-region logo, resolved at runtime. Falls back to the neutral mark
      // if a region's file has not been supplied yet.
      logo: region.logo,
      fallback: DEFAULT_LOGO,
    };
  },
};
</script>
